import type { ReportTemplate } from '~/gql/reports/reports'
import { useTranslation } from 'react-i18next'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card'
import { tourAnchor } from '~/helpers/tour/anchors'
import ReportScheduleForm from './ReportScheduleForm'

type Props = {
  /** Nul pour un modèle pas encore créé : il faut l'enregistrer avant de programmer son envoi. */
  template: ReportTemplate | null
  onSaved: () => void
}

/** L'envoi récurrent du modèle par mail (#163), CSV en pièce jointe. */
function ReportScheduleCard({ template, onSaved }: Props) {
  const { t } = useTranslation()
  return (
    <Card {...tourAnchor('reports.schedule')}>
      <CardHeader>
        <CardTitle>{t('reports.schedule.title')}</CardTitle>
        <CardDescription>{t('reports.schedule.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        {template
          // Clé = modèle : l'envoi d'un autre modèle repart de son propre réglage.
          ? <ReportScheduleForm key={template.id} template={template} onSaved={onSaved} />
          : <p className="text-sm text-muted-foreground">{t('reports.schedule.saveFirst')}</p>}
      </CardContent>
    </Card>
  )
}

export default ReportScheduleCard
